var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgInsurance = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 7.292 13 4.058l7.625 3.234c.246.104.38.325.375.533-.017 3.808-1.6 10.387-7.763 13.337a.548.548 0 0 1-.47 0C6.6 18.208 5.02 11.633 5 7.821c0-.209.13-.425.375-.534v.005zm16.03-1.842-7.847-3.33a1.345 1.345 0 0 0-1.116 0L4.596 5.45c-.917.387-1.6 1.292-1.596 2.383.02 4.134 1.72 11.696 8.9 15.134a2.545 2.545 0 0 0 2.2 0c7.183-3.438 8.88-11 8.9-15.134.004-1.091-.68-1.996-1.596-2.383zm-3.697 5.258a1 1 0 0 0-1.412-1.412L11.67 13.92l-1.958-1.959A1 1 0 0 0 8.3 13.374l2.666 2.668a.996.996 0 0 0 1.412 0l5.33-5.334z",
    fill: "#1A202C",
    fillRule: "nonzero"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInsurance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/insurance.d53b4ad9.svg";
export { ForwardRef as ReactComponent };